import { useInjection } from '@cp/shared/di';
import { CATALOG_ITEM_STORAGE_SERVICE } from '../di';

export const useCatalogItemStorageService = () => useInjection(CATALOG_ITEM_STORAGE_SERVICE);
